import { useCallback, useEffect } from 'react';

// local imports
import { CampaignService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils } from 'app/utils';

const useCampaignDetailService = campaignId => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    const campaignDetail = await CampaignService.getCampaignDetail(campaignId);
    const campaignDetailData = campaignDetail?.data?.data;

    const { start_date, end_date, ...rest } = campaignDetailData;

    return {
      start_date: FormatUtils.convertDate(start_date),
      end_date: FormatUtils.convertDate(end_date),
      ...rest
    };
  }, [campaignId]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useCampaignDetailService;
